import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance from '../../../helper/axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import './gateway.css';
import moment from 'moment'

import "react-datepicker/dist/react-datepicker.css";
import {clickColor,inArray} from './../../../library/util';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import Typography from "@material-ui/core/Typography";

const MyNewTitle = ({ text, variant }) => (
  <Typography
    variant={variant}
    style={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }}
  >
    {text}
  </Typography>
);



function GatewayBaselineGenerator() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedrowList,setSelectedRowList]=useState([]);
    // var date = new Date();
    // date.setDate(date.getDate() - 2);
    // console.log(date)
    // console.log(new Date())
    const [startDate, setStartDate] = useState(new Date(Date.now() - 86400000).setHours(23,59,0,0));
    // console.log('Yesterda Date='+new Date(Date.now() -86400000-86400000));
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }

      const setRowBackground = (selectedRow)=>{
        console.log('hey');
        console.log('38 ====')
        console.log(selectedRow)
        let tempObj={};
        // tempObj[selectedRow.tableData.id]=false;
        // console.log(tempObj)
        // setTempBool()
        console.log(selectedRow.tableData.id)
        console.log(selectedrowList)
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
          console.log('here')
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{
          console.log('here not')
          setSelectedRow(5000)
          //setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
          removeItemOnce(selectedrowList,selectedRow.tableData.id);
          
        }
        console.log('52 line')
        console.log(selectedrowList)
        
        
      }
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }

    checkUserTypeFn(history);

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)
      if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user' && usertype!='owneradmin'){
        history.push('/');
     }
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    const ResetFilter = () => {
      setMessage('')
      setStartDate(new Date(Date.now() - 86400000))
    }
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    
    axiosIntance.get(baseUrl+'/reports/gatewayBaselineGenerator?f1='+moment(startDate).format('YYYY-MM-DD'), {}).then(response => {
  
        if (response.data.result.length > 0) {
          console.log('data we have')
          response.data.result.forEach((i,j)=>{
            console.log(i);
            i.decline_percent=roundToTwo(i.decline_percent*100)+"%";
          });
          setReportData(response.data.result);
          
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{

    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+'/reports/gatewayBaselineGenerator/download?f1='+moment(startDate).format('YYYY-MM-DD')+"&token="+token;
    
  }

  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <label>Date for Report</label>
    <div class="input-bar">
    <div class="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd"
      selected={startDate}
      onChange={(date) => setStartDate(date)}
      placeholder='Date for Report'
      />
    </div>
    <div class="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div class='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    <div className='delete-div'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div>
  </div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
            columns={[
              { title: "Group.ID", field: "group_id" },
              { title: "Group", field: "group" },
              { title: "Count.of.Declines", field: "count_of_declines" },
              { title: "Total.Count", field: "total" },
              { title: "Decline.Percent", field: "decline_percent" },
            ]}
            data={
                reportData
            }
             title="Gateway Baseline Generator Report"
            // title={<MyNewTitle variant="h6" text="Gateway Baseline Generator Report" />}
            // components={{
            //   Toolbar: (props) => (
            //     <div
            //       style={{
            //         alignItems: "center",
            //         // justifyContent: "center",
            //         // display: "flex"
            //       }}
            //     >
            //       <MyNewTitle {...props} />
            //     </div>
            //   )
            // }}
            options={{
                actionsColumnIndex: -1,
                addRowPosition: "first",
                pageSize:10,
                loadingType: 'linear',
                paging: false,
                exportButton: true,
                maxBodyHeight: '500px',
                headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },

             
                // maxBodyHeight: "60vh",
                // headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
                // maxBodyHeight: 600,
                // exportFileName:"test excel",
                //  exportDelimiter:""
              }}
              // components={{
              //   OverlayLoading: props => (<div>Heye</div>)
              // }}
          />
        }
        </section>
       
      </div>

    )
}

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default GatewayBaselineGenerator
